import { create } from 'zustand';

type SetRunEditOpenArgs = { createMode: true; path?: string } | { createMode: false; toolName: string };

type ToolStore = {
  runEditOpen: boolean;
  runEditCreateMode: boolean;
  runEditToolName: string | null;
  runEditPath: string | null;

  setRunEditOpen: (args: SetRunEditOpenArgs) => void;
  closeModal: () => void;
};

export const useToolStore = create<ToolStore>((set, get) => ({
  runEditOpen: false,
  runEditCreateMode: false,
  runEditToolName: null,
  runEditPath: null,

  setRunEditOpen(args) {
    set({
      runEditOpen: true,
      runEditCreateMode: args.createMode,
      runEditToolName: 'toolName' in args ? args.toolName : null,
      runEditPath: 'path' in args ? args.path : null
    });
  },

  closeModal() {
    set({ runEditOpen: false });
  }
}));
